import {StaffResponse, TimeTableResponse} from "./timeTable";
import instance from "./axios";


export const callGetAllAvailableStaff = (semesterId: string) => instance.get<StaffResponse[]>("api/semesters/" + semesterId + "/staff");

export const callGetStaffTimeTable = (semesterId: string, staffId: string) => instance.get<TimeTableResponse>("api/semesters/" + semesterId + "/staff/" + staffId + "/activities");